
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import JSEncrypt from 'jsencrypt';
import API from '@/api/api_sign'
import axios from 'axios'
export default {
name: 'signIn',
components: {
ViewBox, XHeader, Box, XButton
},
data(){
return {
isActive:false,
falseword:'',
isActive1:false,
falseword1:'',
mobile: '',
code: '',
codeVal: '获取验证码',
codeFlog: false,
wait: 60,
show:false,
openId:""
}
},
mounted:function(){

},
methods: {









check(){
if (this.mobile === "") {
this.isActive = true;
this.falseword = '手机号码不能为空'
}else if(this.mobile.length!=11){
this.isActive = true;
this.falseword = '手机号码错误'
}else{
this.isActive = false;
this.falseword='';
}

},
check1(){
if (this.code === "") {
this.isActive1 = true;
this.falseword1 = '验证码不能为空'
}else{
this.isActive1 = false;
this.falseword1 = ''
}
},
register(){
if (this.mobile === "") {
this.isActive = true;
this.falseword = '手机号码不能为空'
return;
}
if(this.mobile.length!=11){
this.isActive = true;
this.falseword = '手机号码错误'
return;
}
if (this.code === "") {
this.isActive1 = true;
this.falseword1 = '验证码不能为空'
return;
}
let encryptor = new JSEncrypt()
let publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB'
encryptor.setPublicKey(publicKey) 
let passwordEncryp = encryptor.encrypt(this.mobile)
var params = {"phone":passwordEncryp,"code":this.code,"channel":"sign"};

API.loginIn(params).then((res)=>{
if (res.code == '000000') {
this.$store.dispatch('userInfoAction',res.data);
window.localStorage.setItem('userInfo',JSON.stringify(res.data));
if(res.data.realNameStatus=="0"){
this.$router.push("/check");
}else{
this.$router.push("/");
}
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},
getCode(){
if (this.codeFlog)return;
if(this.mobile !=="" && this.mobile.length===11){
this.time();
let encryptor = new JSEncrypt()
let publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAykMtXKdPRM4YX6vEuhjsF4ihwwXjng0EAEHn2ujTPcDgkfpeNeLzADIwLe8nV7PPnOrUNrYl57xKLVBmnX/qw/5oDNNMDUkpL0aIFiIKdKJV8ahUyp+klQir/FnydAhGcDjLgkHj9WEdnGiyFJUDEUDasqyBB/OsNGuGIc4PW8AgjYjHBnL7gZyMhQ1FSLG9w0AePDaGQEymhCsY+7m1LNLAq89Gm5fx0A/hUR8117iaa9DVKzJnS3gu+m1vEHIh9b9ui121pUVgNYA8td3jNCxY9Qdwfi8+vms3inDbFRHpj+HHnlO+vlfO4lP+zXHQ7otVlevCt4mkwyqF1HLTXwIDAQAB'
encryptor.setPublicKey(publicKey) 
let passwordEncryp = encryptor.encrypt(this.mobile)
let param = new FormData();
param.append("phone",passwordEncryp);
param.append("nide","login_code");
param.append("channel",'sign');
API.getCode(param).then(res => {
if (res.code == '000000') {

}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
});
}else{
this.isActive = true;
this.falseword = '手机号码错误'
}
},
time() {
if (this.wait === 0) {
this.codeFlog = false;
this.codeVal = "获取验证码";
this.wait = 60;
} else {
this.codeFlog = true;
this.codeVal = "重新发送(" + this.wait + ")";
this.wait--;
setTimeout( () =>{
this.time()
}, 1000);
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/login.vue